import React from 'react'
import Head from "next/head";
import SchemaTags from "@/components/common/SchemaTags";
import CartsAndKiosks from '@/components/outlet/CartsAndKiosks';

const cartsAndKiosks = () => {
  return (
    <>
      <Head>
      <title>QueueBuster POS for Carts and Kiosks | Simplify Billing and Operations</title>
      <meta name="description" content="Streamline your cart and kiosk operations with QueueBuster POS. Enjoy fast billing, inventory management, and seamless customer service tailored for small spaces." />
        <link rel="canonical" href="https://queuebuster.co/outlet/carts-and-kiosks" />
        <link rel="alternate" href="https://queuebuster.co/outlet/carts-and-kiosks" hrefLang="en-us" />
        <meta property="og:title" content="QueueBuster POS for Carts & Kiosks: Smart Solutions for Small Businesses" />
        <meta property="og:description" content="Efficiently manage your cart or kiosk business with QueueBuster POS. Simplify billing, track inventory, and enhance customer experience with our all-in-one solution." />
        <meta property="og:image" content="https://quebuster.s3.ap-south-1.amazonaws.com/website/assets/zoomed-out+image+of+a+pop-up+kiosk+in+the+middle+of+a+shopping+mall%2C+one+Indian+person+standing+behind+the+counter%2C+pov+is+from+far+away.png" />
        <meta property="og:url" content="https://queuebuster.co/outlet/carts-and-kiosks" />
      </Head>
         <SchemaTags page="carts-and-kiosks" />
      <CartsAndKiosks />
    </>
  )
}

export default cartsAndKiosks